module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools"
  }, [_c('h1', [_vm._v("Tools")]), _vm._v(" "), _c('h2', [_vm._v("Locking")]), _vm._v(" "), _c('lock-panel', {
    attrs: {
      "title": "All items",
      "subtitle": "Apply lock to all items",
      "items": _vm.lockable,
      "notMatched": _vm.lockable
    }
  }), _vm._v(" "), _c('lock-panel', {
    attrs: {
      "title": "Favorited",
      "subtitle": "Keep your favorited items safe",
      "items": _vm.favorited,
      "notMatched": _vm.notFavorited
    }
  }), _vm._v(" "), _c('lock-panel', {
    attrs: {
      "title": "Unique and best duplicates",
      "subtitle": "Lock all unique items",
      "items": _vm.bestDuplicates,
      "notMatched": _vm.worstDuplicates
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Transfering")]), _vm._v(" "), _vm._l((_vm.tagsDefinitions), function(ref) {
    var tag = ref[0];
    var definition = ref[1];

    return _c('transfer-panel', {
      key: tag,
      attrs: {
        "color": definition.color,
        "title": 'Tag ' + tag,
        "items": _vm.forTag(tag),
        "targets": _vm.characters
      }
    }, [_vm._v("\n    Move items tagged with tag "), _c('strong', [_vm._v(_vm._s(tag))])])
  }), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Favorites",
      "items": _vm.favorited,
      "targets": _vm.characters
    }
  }, [_vm._v("\n    Move favorited items\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Blue mods to vault",
      "items": _vm.blueModsLessThan3,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Store for future\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Blue mods to characters",
      "items": _vm.blueModsMoreThan3,
      "targets": [_vm.character]
    }
  }, [_vm._v("\n    Exchange them to legendary\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Unique / best duplicates",
      "items": _vm.uniqueWeapon,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Store all unique not equpped weapon to vault, left duplicates are safe to dismantle\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Worst duplicates",
      "items": _vm.worstDuplicatesToMove,
      "targets": _vm.characters
    }
  }, [_vm._v("\n    Move words duplicates to selected character for dismantle\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Not equipped weapon to vault",
      "items": _vm.notEquippedWeapon,
      "sources": _vm.characters,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Make some space for new items\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Not equipped armor to vault",
      "items": _vm.notEquippedArmor,
      "sources": _vm.characters,
      "targets": [_vm.vault]
    }
  }, [_vm._v("\n    Make some space for new items\n  ")]), _vm._v(" "), _c('transfer-panel', {
    attrs: {
      "title": "Trash",
      "items": _vm.trashItems,
      "targets": _vm.characters.concat( [_vm.vault])
    }
  }, [_vm._v("\n    Not important items\n  ")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a80ec45","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Tools.vue
// module id = 550
// module chunks = 1